import * as React from 'react';
import clsx from 'clsx';
import searchIcon from '@/assets/images/svg/search_icon.svg';

/** Props for `SearchBar`. Pure controlled — caller owns the value and applies debouncing if needed. */
export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/** Reusable search input with leading magnifier icon. */
export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className,
}) => (
  <div className='relative'>
    <input
      type='text'
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={clsx(
        'h-[39px] w-full',
        'rounded-80 border border-gray-250',
        'pl-[40px] pr-4',
        'font-sans text-14 font-normal leading-[12px] tracking-normal',
        'text-gray-550 placeholder:text-gray-550',
        'transition-colors focus:border-brand-400 focus:outline-none',
        // Default background if not overridden in className
        !className?.includes('bg-') && 'bg-white',
        className
      )}
    />
    <img
      src={searchIcon}
      alt='Search'
      className='pointer-events-none absolute left-[14px] top-1/2 size-[14px] -translate-y-1/2 select-none'
    />
  </div>
);

export default SearchBar;
